// import { Injectable } from '@angular/core';
// import { AppConsts } from '@shared/AppConsts';
// import { FileDto } from '@shared/service-proxies/service-proxies';

// @Injectable()
// export class FileDownloadService {
//     downloadTempFile(file: FileDto) {
//         const url =
//             AppConsts.remoteServiceBaseUrl +
//             '/File/DownloadTempFile?fileType=' +
//             file.fileType +
//             '&fileToken=' +
//             file.fileToken +
//             '&fileName=' +
//             file.fileName;
//         location.href = url; //TODO: This causes reloading of same page in Firefox
//     }
// }


import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppConsts } from '@shared/AppConsts';
import { FileDto } from '@shared/service-proxies/service-proxies';

@Injectable()
export class FileDownloadService {
    constructor(private http: HttpClient) {}

    downloadTempFile(file: FileDto) {
        const url = AppConsts.remoteServiceBaseUrl + '/File/DownloadTempFile';
        const token = abp.auth.getToken();

        const headers = new HttpHeaders({
            'Authorization': 'Bearer ' + token,
            'Content-Type': 'application/json'
        });

        this.http.get(url, {
            headers: headers,
            params: {
                fileType: file.fileType,
                fileToken: file.fileToken,
                fileName: file.fileName,
                fileUId: file.fileUId
            },
            responseType: 'blob'
        }).subscribe(blob => {
            this.downloadFile(blob, file.fileName, file.fileType);
        });
    }

    private downloadFile(blob: Blob, fileName: string, fileType: string) {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
    }
}
